import i18next from 'i18next';

i18next.addResources('es_CL', 'billingType', {
  ticket: 'Boleta',
  invoice: 'Factura'
});

i18next.addResources('es_CR', 'billingType', {
  ticket: 'Ticket electrónico',
  invoice: 'Factura electrónica'
});

i18next.addResources('es_CL', 'documentType', {
  identityCard: 'RUT / RUN',
  taxID: 'RUC'
});

i18next.addResources('es_CR', 'documentType', {
  identityCard: 'Cédula de identidad',
  taxID: 'Cédula jurídica'
});

i18next.addResources('es_CL', 'countrySearch', {
  country: 'cl'
});

i18next.addResources('es_CR', 'countrySearch', {
  country: 'cr'
});

i18next.addResources('es_AR', 'countrySearch', {
  country: 'ar'
});
